<template>
  <div class="mainView">
    <el-form ref="form" :model="form">
      <el-row  style="border-bottom: 1px solid #f5f5f5">
        <el-col :span="12"> 
          <div class="eachRow">
            <div class="titleView">
              <div class="rowLine"></div>
              <span class="eachRowTitle">商品基本信息</span>
            </div>
          
            <div class="goodsInfoView">
              <el-image style="width: 150px; height: 150px" v-if="form.image" :fit="'cover'" referrerpolicy='no-referrer'
                :src="form.image" :preview-src-list="[form.image]" />
  
              <div class="goodsInfoText">
                <div class="textInLine">
                  <span class="textBetween">产品名称</span>
                  <span>{{ form.goodsName }}</span>
                </div>
                <div class="textInLine">
                  <span class="textBetween">批准文号</span>
                  <span>{{ form.approvalNumber }}</span>
                </div>
                <div class="textInLine">
                  <span class="textBetween">规格</span>
                  <span>{{ form.specification }}</span>
                </div>
                <div class="textInLine">
                  <span class="textBetween">生产厂家</span>
                  <span>{{ form.factory }}</span>
                </div>
                <div class="textInLine">
                  <span class="textBetween">产地</span>
                  <span>{{ form.origin ? form.origin : '' }}</span>
                </div>
              </div>
            </div>
            <div class="fillView">
              <el-form-item label="商品标题" required>
                <el-input disabled v-model="form.goodsSkuTitle" style="width: 400px"></el-input>
              </el-form-item>
              <el-form-item label="商品图片" style="margin-bottom: 0px !important">
              </el-form-item>
              <div class="img-list" v-if="form.goodsSkuImageList">
                <div class="img" v-for="(item, key) in form.goodsSkuImageList" :key="key">
                  <el-image style="width: 150px; height: 150px" :fit="'cover'" :src="item" :preview-src-list="[item]" />
                </div>
              </div>
              <div style="display: flex;">
                <span style="font-size: 14px;margin-top: 10px;">批件/药检报告等：</span>
                <el-upload class="upload-demo" :disabled="true" action="https://gateway.cbyyk.com/product/goodsbase/upload"
                  multiple :on-preview="preview" accept=".jpg,.jpeg,.png,.pdf" :file-list="fileList">
                  <!-- <el-button size="small"
                        type="primary"
                        disabled>点击上传</el-button> -->
                  <!-- <div slot="tip"
                  class="el-upload__tip">上传pdf或图片，且不超过10M</div> -->
                </el-upload>
              </div>
            </div>
          </div>
          <div class="mt20" style="margin: 20px">
            <el-button type="primary" style="width: 160px" size="small" @click="auditSubmit(1)"
              v-if="status == 'AWAIT'">审核通过</el-button>
  
            <el-button type="primary" style="width: 160px" size="small" v-if="status == 'AWAIT'"
              @click="auditSubmit(2)">驳回</el-button>
            <el-button size="small" style="width: 160px" @click="back()">返回</el-button>
          </div>
          <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[url]" />
        </el-col>
  
        <el-col :span="12"  v-if="form.status =='FAIL'">
          <div class="eachRow" >
            <div class="titleView">
              <div class="rowLine"></div>
              <span class="eachRowTitle">驳回原因</span>
            </div>
          </div>
          <div style="margin-left:20px;">
            <el-input disabled v-model="form.rejectReason" type="textarea" style="width:400px"></el-input>
          </div>
        </el-col>
      </el-row> 
    </el-form>

  </div>
</template>
<script>
import {
  goodsCheckDetail,
  goodsCheckResult,
} from "@/api/goodsManage/baseDepot.js";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: { ElImageViewer },
  data() {
    return {
      showViewer: false,
      url: '',
      status: null,
      fileList: [],
      form: {
        goodsSkuImageList: [],
      },
    };
  },
  created() { },
  mounted() {
    const { skuId, goodsId, status } = this.$route.query;
    this.status = status; //审核状态
    if (skuId && goodsId) {
      this.getDetail(goodsId, skuId);
    }
  },
  methods: {
    // 点击已上传的文件
    preview(file) {
      if (file.url.indexOf('.pdf') > -1 || file.url.indexOf('.PDF') > -1) {
        window.open(file.url)
      } else {
        this.url = file.url
        this.showViewer = true
      }
    },
    // 关闭弹窗
    closeViewer() {
      this.showViewer = false
    },
    back() {
      this.$router.push("./goodsManage-goodsAudit-index");
    },

    // 提交审核
    auditSubmit(type) {
      const { skuId, goodsId } = this.$route.query;
      let params = {};

      if (type == 2) {
        const h = this.$createElement;
        this.$prompt(h("p", null, [h("p", null)]), "驳回原因", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(({ value }) => {
            if (value != "" && value != undefined) {
              value = value.trim();
            }
            if (value == "" || value == undefined) {
              this.$message({
                message: "请填写驳回原因！",
                type: "error",
              });
              return;
            }
            params = {
              goodsId: goodsId,
              skuId: skuId,
              status: "FAIL",
              rejectReason: value,
            };
            this.goodsCheckResult(params);
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              type: "info",
              message: "取消输入",
            });
          });
      } else {
        params = {
          goodsId: goodsId,
          skuId: skuId,
          status: "PUTAWAY",
        };
        this.goodsCheckResult(params);
      }
    },

    // 提交审核
    goodsCheckResult(params) {
      goodsCheckResult(params).then((res) => {
        if (res && res.success) {
          this.$message({
            type: "success",
            message: "提交成功",
          });
          this.back();
        }
      });
    },

    getDetail(goodsId, skuId) {
      const params = {
        goodsId: goodsId,
        skuId: skuId,
      };
      goodsCheckDetail(params).then((res) => {
        if (res.code === 0) {
          this.form = res.data;
          if (res.data.goodsSkuImageList != "" && res.data.goodsSkuImageList != undefined) {
            this.form.goodsSkuImageList = res.data.goodsSkuImageList.split(",");
          } else {
            this.form.goodsSkuImageList = [];
          }
          this.form.image = res.data.image;
          this.fileList = res.data.goodsSkuFileList ? JSON.parse(res.data.goodsSkuFileList) : []
          console.log(this.form);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.mainView {
  height: 100%;

  ::v-deep .el-upload {
    display: none;
  }

  .header {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
    height: 56px;
    line-height: 56px;
    padding: 0 24px;
    border-bottom: 1px solid #f2f2f2;
  }

  background-color: #fff;

  .eachRow {
    background-color: #fff;
    border-radius: 4px;
    padding: 16px 24px;
    display: flex;
    flex-direction: column;

    .table {
      padding: 16px 16px;
      border-bottom: 1px solid #f5f5f5;

      .tableBox {
        display: flex;
        justify-content: space-between;
        align-content: center;

        .spanStyle {
          font-size: 14px;

          .inputStyle {
            width: 100px;
            margin-left: 16px;
          }
        }
      }
    }
  }

  .titleView {
    display: flex;
    align-items: center;

    .rowLine {
      width: 4px;
      border-color: 1px;
      background-color: var(--main-color);
      height: 16px;
      margin-right: 8px;
    }

    .eachRowTitle {
      font-size: 16px;
      color: #f5222d;
      font-weight: 600;
    }
  }

  .goodsInfoView {
    display: flex;
    align-items: center;
    padding: 15px;
    margin-top: 30px;
    position: relative;

    .detailBtn {
      position: absolute;
      top: 0px;
      right: 15px;
    }

    img {
      width: 130;
      height: 130px;
    }

    .goodsInfoText {
      font-size: 14px;
      color: #262626;
      display: flex;
      flex-direction: column;
      height: 130px;
      justify-content: space-between;
      margin-left: 45px;

      .textInLine {
        display: flex;
        align-items: center;

        .textBetween {
          width: 70px;
          text-align-last: justify;
          margin-right: 50px;
        }
      }
    }
  }

  .fillView {
    padding: 15px;
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }

    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }

  .img-list {
    display: flex;
    justify-content: flex-start;

    .img {
      width: 150px;
      height: 150px;
      border: solid 1px #eee;
      margin-right: 10px;
    }
  }
}
</style>
